import 'uni-pages';
import Vue from 'vue'
import Page from './demo/packageMall/brandList.vue'
createPage(Page)